import { createAction, props } from '@ngrx/store';
import { SnackbarLevel } from '../../data-model/types/snackbar-level.type';

const feature = '[Snackbar]';

export const showSnackbar = createAction(`${feature} Show Snackbar`, props<{ message: string; level: SnackbarLevel; time?: number }>());
export const hideSnackbar = createAction(`${feature} Hide Snackbar`);
